import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MapPin, Download, MessageSquare, Phone, BarChart2, Info, Mail, Menu, X, LogIn, User, ChevronDown, Settings, LogOut ,Brain} from 'lucide-react';
import {useUser} from '../UserContext'

export default function Header({ isMenuOpen, setIsMenuOpen }) {
  const { currentUser, userData, logout } = useUser();
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(false);
  const name = userData?.name;

  const isLoggedIn = !!currentUser;
  const accountDisplay = isLoggedIn ? (name || 'Account') : 'Signup';
  const accountPath = isLoggedIn ? '/profile' : '/signup';
  const accountIcon = isLoggedIn ? <User className="w-4 h-4 mr-2" /> : <LogIn className="w-4 h-4 mr-2" />;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.account-dropdown')) {
        setIsAccountDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      setIsAccountDropdownOpen(false);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const navLinks = [
    { name: 'Home', path: '/', icon: <MapPin className="w-4 h-4 mr-2" /> },
    { name: 'Local Access Hubs', path: '/hubs', icon: <MapPin className="w-4 h-4 mr-2" /> },
    { name: 'Offline Resources', path: '/resources', icon: <Download className="w-4 h-4 mr-2" /> },
    { name: 'Community Forum',
       path:isLoggedIn? '/forum':'login',
       icon: <MessageSquare className="w-4 h-4 mr-2" /> },
    { name: 'Transparency Dashboard', path: '/dashboard', icon: <BarChart2 className="w-4 h-4 mr-2" /> },
    { name:isLoggedIn? 'Vita AI':'About Us', 
      path:isLoggedIn? '/gemini':'/about',
      icon:isLoggedIn? <Brain className="w-4 h-4 mr-2" /> :<Info className="w-4 h-4 mr-2" /> },
    { name: 'About Us', path: '/about', icon: <Info className="w-4 h-4 mr-2" /> },
    { name: 'Contact', path: '/contact', icon: <Mail className="w-4 h-4 mr-2" /> },
   
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <Link to="/" className="text-2xl font-bold text-green-600">
              VitaBridge
            </Link>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              {navLinks.slice(1, 6).map(link => (
                <NavLink
                  key={link.name}
                  to={link.path}
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive ? 'bg-green-600 text-white' : 'text-gray-600 hover:bg-green-500 hover:text-white'}`
                  }
                >
                  {link.name}
                </NavLink>
              ))}
              
              {/* Account Dropdown */}
              <div className="relative account-dropdown">
                <button
                  onClick={() => setIsAccountDropdownOpen(!isAccountDropdownOpen)}
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-600 hover:bg-green-500 hover:text-white transition-colors"
                >
                  {accountIcon}
                  {accountDisplay}
                  <ChevronDown className={`w-4 h-4 ml-1 transition-transform ${isAccountDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                
                {isAccountDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                    {isLoggedIn ? (
                      <>
                        <Link
                          to={isLoggedIn? "/profile": "/login"}
                          onClick={() => setIsAccountDropdownOpen(false)}
                          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                          <User className="w-4 h-4 mr-2" />
                          Profile
                        </Link>
                        <Link
                          to={isLoggedIn? "/about": "/login"}
                          onClick={() => setIsAccountDropdownOpen(false)}
                          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                          <BarChart2 className="w-4 h-4 mr-2" />
                          About Us
                        </Link>
                        <hr className="my-1" />
                        <button
                          onClick={handleLogout}
                          className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                        >
                          <LogOut className="w-4 h-4 mr-2" />
                          Logout
                        </button>
                      </>
                    ) : (
                      <>
                        <Link
                          to="/signup"
                          onClick={() => setIsAccountDropdownOpen(false)}
                          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                          <LogIn className="w-4 h-4 mr-2" />
                          Sign Up
                        </Link>
                        <Link
                          to="/login"
                          onClick={() => setIsAccountDropdownOpen(false)}
                          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                        >
                          <User className="w-4 h-4 mr-2" />
                          Login
                        </Link>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen ? <X className="block h-6 w-6" /> : <Menu className="block h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.map(link => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-600 hover:bg-green-500 hover:text-white block px-3 py-2 rounded-md text-base font-medium transition-colors"
              >
                <div className="flex items-center">{link.icon} {link.name}</div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}


